import React from 'react';

const ModalLoading = ({text = "Cargando..."}) => {
  return (
    <div className="bg-white p-5"
         style={{ minWidth: "300px", width: "90vw", maxWidth: "1000px", minHeight: "500px" }}>
      <div style={{fontSize: "30px"}} className="container-fluid h-100 ff-bobby">
        <div className="row h-100 justify-content-center align-items-center text-center">
          {text}
        </div>
      </div>
    </div>
  );
};

export default ModalLoading;
